<template>
  <div>
    <div v-if="fms_vehicle || fms_vehicle != null" class="md-layout">
      <v-toolbar
        :src="require('@/assets/images/vuebackground.jpg')"
        style="transform: translateY(0)"
      >
        

        <v-spacer></v-spacer>
        <v-menu :close-on-content-click="false" open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              small
              v-on="on"
            >
              <span style="color:white">Options</span>
            </v-btn>
          </template>
    
          <v-list>
            <v-list-item @click="active = true">
              <v-list-item-title>History Status</v-list-item-title>
            </v-list-item>
            <v-list-group
              v-if="fms_vehicle.vehicle_status != 4 && fms_vehicle.vehicle_status != 3 && fms_vehicle.vehicle_status != 7"
            >
              <template v-slot:activator>
                <v-list-item
                >
                  <v-list-item-title>Change Status</v-list-item-title>
                </v-list-item>
              </template>
              <v-list-item
                v-if="fms_vehicle.vehicle_status == 0 && role.requester"
                class="noprint"
                @click="confirmationChangeStatus(1, 'Request Approval')"
                ><v-list-item-title>Request Approval</v-list-item-title></v-list-item
              >
              <v-list-item
                v-if="fms_vehicle.vehicle_status == 1 && role.approver"
                class="noprint"
                @click="confirmationChangeStatus(3, 'Approve')"
                ><v-list-item-title>Approve</v-list-item-title></v-list-item
              >
                    
              <v-list-item
                v-if="fms_vehicle.vehicle_status == 1 && role.approver"
                class="noprint"
                @click="confirmationChangeStatus(2, 'Reject')"
                ><v-list-item-title>Reject</v-list-item-title></v-list-item
              >
                    
              <v-list-item
                v-if="fms_vehicle.vehicle_status == 2 && role.requester"
                class="noprint"
                @click="confirmationChangeStatus(1, 'Request Approval')"
                ><v-list-item-title>Request Approval</v-list-item-title></v-list-item
              >
              <v-list-item
                v-if="(fms_vehicle.vehicle_status == 5 || fms_vehicle.vehicle_status == 6 || fms_vehicle.vehicle_status == 8 || fms_vehicle.vehicle_status == 9)  && check_object_value(role_name,'name',['Admin','Revert Vehicle'])"
                class="noprint"
                @click="confirmationChangeStatus(3, 'Revert to waiting PKO')"
                ><v-list-item-title>Revert to Waiting PKO</v-list-item-title></v-list-item
              >
            </v-list-group>
          </v-list>
        </v-menu>

        <!-- <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  text
                  small
                  v-if="
                      fms_vehicle.vehicle_status != 4 && fms_vehicle.vehicle_status != 3 && fms_vehicle.vehicle_status != 7
                    "
                >
                <span style="color:white;">Change Status</span>
                </v-btn>
                <v-btn
                  small
                  text
                  @click="active = true"
                >
                  <span style="color:white;">History Status</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                      v-if="fms_vehicle.vehicle_status == 0 && role.requester"
                      class="noprint"
                      @click="confirmationChangeStatus(1, 'Request Approval')"
                      >Request Approval</v-list-item
                    >
                    <v-list-item
                      v-if="fms_vehicle.vehicle_status == 1 && role.approver"
                      class="noprint"
                      @click="confirmationChangeStatus(3, 'Approve')"
                      >Approve</v-list-item
                    >
                    
                    <v-list-item
                      v-if="fms_vehicle.vehicle_status == 1 && role.approver"
                      class="noprint"
                      @click="confirmationChangeStatus(2, 'Reject')"
                      >Reject</v-list-item
                    >
                    
                    <v-list-item
                      v-if="fms_vehicle.vehicle_status == 2 && role.requester"
                      class="noprint"
                      @click="confirmationChangeStatus(1, 'Request Approval')"
                      >Request Approval</v-list-item
                    >
                    <v-list-item
                      v-if="(fms_vehicle.vehicle_status == 5 || fms_vehicle.vehicle_status == 6 || fms_vehicle.vehicle_status == 8 || fms_vehicle.vehicle_status == 9)  && check_object_value(role_name,'name',['Admin','Revert Vehicle'])"
                      class="noprint"
                      @click="confirmationChangeStatus(3, 'Revert to waiting PKO')"
                      >Revert to Waiting PKO</v-list-item
                    >
              </v-list>
            </v-menu> -->
    
        <v-btn icon @click="closeDetail()">
          <v-icon style="color:white;">mdi-export</v-icon>
        </v-btn>

        <template v-slot:extension>
            <v-toolbar-title style="color:white;">
          <p
              v-if="fms_vehicle.vehicle_status == 0"
              style="text-align: left; font-weight:bold;"
            >
              REGISTERED
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 1"
              style="text-align: left; font-weight:bold;"
            >
              WAITING APPROVAL
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 2"
              style="text-align: left; font-weight:bold;"
            >
              REJECTED
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 3"
              style="text-align: left; font-weight:bold;"
            >
              WAITING PKO
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 4"
              style="text-align: left; font-weight:bold;"
            >
              ACTIVE
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 5"
              style="text-align: left; font-weight:bold;"
            >
              PAYMENT COMPLETE
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 6"
              style="text-align: left; font-weight:bold;"
            >
              TERMINATED BY PAYMENT
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 7"
              style="text-align: left; font-weight:bold;"
            >
              ACTIVE OWNERSHIP
            </p>
            <p
              v-if="(fms_vehicle.vehicle_status == 8)"
              style="text-align: left; font-weight:bold;"
            >
            {{ fms_vehicle.vehicle_return_date ? 'REPO at '+ $moment(fms_vehicle.vehicle_return_date).format('DD-MM-YYYY'):'REPO' }}
            </p>
            <p
              v-if="(fms_vehicle.vehicle_status == 9)"
              style="text-align: left; font-weight:bold;"
            >
            {{ fms_vehicle.vehicle_return_date ? 'RETURN at '+ $moment(fms_vehicle.vehicle_return_date).format('DD-MM-YYYY'):'RETURN' }}
              
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 10"
              style="text-align: left; font-weight:bold;"
            >
              STNK Problem
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 11"
              style="text-align: left; font-weight:bold;"
            >
              Key Problem
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 12"
              style="text-align: left; font-weight:bold;"
            >
              STNK & Key Problem
            </p>
            <p
              v-if="fms_vehicle.vehicle_status == 13"
              style="text-align: left; font-weight:bold;"
            >
              In Service
            </p>
        </v-toolbar-title>
        </template>
      
      </v-toolbar>

      <!-- <v-navigation-drawer
        v-model="drawer"
        absolute
        src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
        temporary
      >
        <v-list
          nav
          dense
        >
          <v-list-item-group
            v-model="group"
            active-class="deep-purple--text text--accent-4"
          >
            <v-list-item v-if="fms_vehicle.vehicle_status == 1 && role.approver"
                class="noprint"
                @click="confirmationChangeStatus(3, 'Approve')">
              <v-list-item-title>Foo</v-list-item-title>
            </v-list-item>

            <v-list-item @click="active = true">
              <v-list-item-title>Bar</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Fizz</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Buzz</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer> -->

      <md-dialog :md-active.sync="active" >
        <md-dialog-title>
          History Status
          <md-button style="float:right;" class="md-dense md-round md-icon-button" @click="active = false">
            <md-icon>close</md-icon>
          </md-button>

        </md-dialog-title>
        <md-card class="md-content1 md-scrollbar">
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head><b>Change</b></md-table-head>
                <md-table-head><b>By</b></md-table-head>
                <md-table-head><b>Action</b></md-table-head>
                <md-table-head><b>Status</b></md-table-head>
              </md-table-row>
              <md-table-row
                v-for="(item, index) in fms_vehicle.vehicle_history_status"
                :key="index"
              >
                <md-table-cell>{{ $moment(item.updated_at).utc().format('DD-MM-YYYY HH:mm') }}</md-table-cell>
                <md-table-cell>{{ item.name_by }}</md-table-cell>
                <md-table-cell>
                  <span v-if="item.status_action == 1">Request Approval</span>
                  <span v-if="item.status_action == 2">Approve</span>
                  <span v-if="item.status_action == 3">Reject</span>
                  <span v-if="item.status_action == 4">DP Paid</span>
                  <span v-if="item.status_action == 5">Driver Assigned</span>
                  <span v-if="item.status_action == 6">Revert Waiting PKO</span>
                  <span v-if="item.status_action == 7">Terminated</span>
                  <span v-if="item.status_action == 8">Terminate by Payment</span>
                  <span v-if="item.status_action == 9">Complete By Payment</span>
                  <span v-if="item.status_action == 10">Change to Ownership</span>
                </md-table-cell>
                <md-table-cell>
                  <span v-if="item.status == 0">Registered</span>
                  <span v-if="item.status == 1">Waiting Approval</span>
                  <span v-if="item.status == 2">Rejected</span>
                  <span v-if="item.status == 3">Waiting PKO</span>
                  <span v-if="item.status == 4">Active</span>
                  <span v-if="item.status == 5">Payment Completed</span>
                  <span v-if="item.status == 6">Terminate by Payment</span>
                  <span v-if="item.status == 7">Active Ownership</span>
                  <span v-if="item.status == 8">{{ item.status_date ? 'Repo at '+ $moment(item.status_date).format('DD-MM-YYYY'):'Repo' }}</span>
                  <span v-if="item.status == 9">{{ item.status_date ? 'Return at '+ $moment(item.status_date).format('DD-MM-YYYY'):'Return' }}</span>
                  <span v-if="item.status == 10">STNK Problem</span>
                  <span v-if="item.status == 11">Key Problem</span>
                  <span v-if="item.status == 12">STNK & Key Problem</span>
                  <span v-if="item.status == 13">In Service</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </md-dialog>

    
    
      <!-- <md-toolbar class="md-dense color">
        <h3 class="md-title" style="flex:1; margin-left:10px;">
          <p
            v-if="fms_vehicle.vehicle_status == 0"
            style="text-align: left; font-weight:bold;"
          >
            REGISTERED
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 1"
            style="text-align: left; font-weight:bold;"
          >
            WAITING APPROVAL
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 2"
            style="text-align: left; font-weight:bold;"
          >
            REJECTED
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 3"
            style="text-align: left; font-weight:bold;"
          >
            WAITING PKO
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 4"
            style="text-align: left; font-weight:bold;"
          >
            ACTIVE
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 5"
            style="text-align: left; font-weight:bold;"
          >
            PAYMENT COMPLETE
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 6"
            style="text-align: left; font-weight:bold;"
          >
            TERMINATED BY PAYMENT
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 7"
            style="text-align: left; font-weight:bold;"
          >
            ACTIVE OWNERSHIP
          </p>
          <p
            v-if="(fms_vehicle.vehicle_status == 8)"
            style="text-align: left; font-weight:bold;"
          >
          {{ fms_vehicle.vehicle_return_date ? 'REPO at '+ $moment(fms_vehicle.vehicle_return_date).format('DD-MM-YYYY'):'REPO' }}
          </p>
          <p
            v-if="(fms_vehicle.vehicle_status == 9)"
            style="text-align: left; font-weight:bold;"
          >
          {{ fms_vehicle.vehicle_return_date ? 'RETURN at '+ $moment(fms_vehicle.vehicle_return_date).format('DD-MM-YYYY'):'RETURN' }}
            
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 10"
            style="text-align: left; font-weight:bold;"
          >
            STNK Problem
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 11"
            style="text-align: left; font-weight:bold;"
          >
            Key Problem
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 12"
            style="text-align: left; font-weight:bold;"
          >
            STNK & Key Problem
          </p>
          <p
            v-if="fms_vehicle.vehicle_status == 13"
            style="text-align: left; font-weight:bold;"
          >
            In Service
          </p>
        </h3>


        <md-dialog :md-active.sync="active">
          <md-dialog-title>
            History Status
            <md-button style="float:right;" class="md-dense md-round md-icon-button" @click="active = false">
              <md-icon>close</md-icon>
            </md-button>

        </md-dialog-title>
          <md-card class="md-content1 md-scrollbar">
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head><b>Change</b></md-table-head>
                  <md-table-head><b>By</b></md-table-head>
                  <md-table-head><b>Action</b></md-table-head>
                  <md-table-head><b>Status</b></md-table-head>
                </md-table-row>
                <md-table-row
                  v-for="(item, index) in fms_vehicle.vehicle_history_status"
                  :key="index"
                >
                  <md-table-cell>{{ $moment(item.updated_at).utc().format('DD-MM-YYYY HH:mm') }}</md-table-cell>
                  <md-table-cell>{{ item.name_by }}</md-table-cell>
                  <md-table-cell>
                    <span v-if="item.status_action == 1">Request Approval</span>
                    <span v-if="item.status_action == 2">Approve</span>
                    <span v-if="item.status_action == 3">Reject</span>
                    <span v-if="item.status_action == 4">DP Paid</span>
                    <span v-if="item.status_action == 5">Driver Assigned</span>
                    <span v-if="item.status_action == 6">Revert Waiting PKO</span>
                    <span v-if="item.status_action == 7">Terminated</span>
                    <span v-if="item.status_action == 8">Terminate by Payment</span>
                    <span v-if="item.status_action == 9">Complete By Payment</span>
                    <span v-if="item.status_action == 10">Change to Ownership</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span v-if="item.status == 0">Registered</span>
                    <span v-if="item.status == 1">Waiting Approval</span>
                    <span v-if="item.status == 2">Rejected</span>
                    <span v-if="item.status == 3">Waiting PKO</span>
                    <span v-if="item.status == 4">Active</span>
                    <span v-if="item.status == 5">Payment Completed</span>
                    <span v-if="item.status == 6">Terminate by Payment</span>
                    <span v-if="item.status == 7">Active Ownership</span>
                    <span v-if="item.status == 8">{{ item.status_date ? 'Repo at '+ $moment(item.status_date).format('DD-MM-YYYY'):'Repo' }}</span>
                    <span v-if="item.status == 9">{{ item.status_date ? 'Return at '+ $moment(item.status_date).format('DD-MM-YYYY'):'Return' }}</span>
                    <span v-if="item.status == 10">STNK Problem</span>
                    <span v-if="item.status == 11">Key Problem</span>
                    <span v-if="item.status == 12">STNK & Key Problem</span>
                    <span v-if="item.status == 13">In Service</span>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </md-dialog>

        <md-button class="nonprint; color md-dense" @click="active = true"
          >History Status</md-button
        >
        <md-menu md-direction="bottom-start">
          <md-button
            v-if="
              fms_vehicle.vehicle_status != 4 && fms_vehicle.vehicle_status != 3 && fms_vehicle.vehicle_status != 7
            "
            class="nonprint; color md-dense"
            md-menu-trigger
            >Change Status</md-button
          >
          <md-menu-content>
            <md-menu-item
              v-if="fms_vehicle.vehicle_status == 0 && role.requester"
              class="noprint"
              @click="confirmationChangeStatus(1, 'Request Approval')"
              >Request Approval</md-menu-item
            >
            <md-menu-item
              v-if="fms_vehicle.vehicle_status == 1 && role.approver"
              class="noprint"
              @click="confirmationChangeStatus(3, 'Approve')"
              >Approve</md-menu-item
            >
            
            <md-menu-item
              v-if="fms_vehicle.vehicle_status == 1 && role.approver"
              class="noprint"
              @click="confirmationChangeStatus(2, 'Reject')"
              >Reject</md-menu-item
            >
            
            <md-menu-item
              v-if="fms_vehicle.vehicle_status == 2 && role.requester"
              class="noprint"
              @click="confirmationChangeStatus(1, 'Request Approval')"
              >Request Approval</md-menu-item
            >
            <md-menu-item
              v-if="(fms_vehicle.vehicle_status == 5 || fms_vehicle.vehicle_status == 6 || fms_vehicle.vehicle_status == 8 || fms_vehicle.vehicle_status == 9)  && check_object_value(role_name,'name',['Admin','Revert Vehicle'])"
              class="noprint"
              @click="confirmationChangeStatus(3, 'Revert to waiting PKO')"
              >Revert to Waiting PKO</md-menu-item
            >
          </md-menu-content>
        </md-menu>
        

        <md-button class="nonprint; color md-icon-button md-dense" @click="closeDetail()"><md-icon>close</md-icon></md-button>

      </md-toolbar> -->

      <div class="md-layout-item md-size-100">
        <md-card>
          <!-- <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <md-icon>directions_car</md-icon>
              <h4 class="title">Vehicle Info</h4>
            </div>
          </md-card-header> -->
          <md-card-content>
            <div class="md-layout">
              <div
                class="md-layout-item md-size-100 md-small-size-100"
                style="margin-bottom:20px;"
              >
                <md-table>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;"
                      >Vehicle No</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_door_no
                    }}</md-table-cell>

                    <md-table-cell style="font-weight:bold;"
                      >Production Year</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_production_year
                    }}</md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;"
                      >Plate No</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_plate_no
                    }}</md-table-cell>

                    <md-table-cell style="font-weight:bold;"
                      >Plate Color</md-table-cell
                    >
                    <md-table-cell>
                      <span v-if="fms_vehicle.vehicle_plate_color == 0"
                        >Kuning</span
                      >
                      <span v-if="fms_vehicle.vehicle_plate_color == 1"
                        >Hitam</span
                      >
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;"
                      >Pool</md-table-cell
                    >
                    <md-table-cell>
                      {{ fms_vehicle.vehicle_pool.pool_name }}
                    </md-table-cell>

                    <md-table-cell style="font-weight:bold;"
                      >Registration Year</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_registration_year
                    }}</md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <!-- <md-table-cell style="font-weight:bold;"
                      >Business Unit</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_business_unit.business_unit_name
                    }}</md-table-cell> -->

                    <md-table-cell style="font-weight:bold;"
                      >Registration Name</md-table-cell
                    >
                    <md-table-cell>
                      <span v-if="fms_vehicle.vehicle_registration_name">{{
                        fms_vehicle.vehicle_registration_name
                      }}</span>
                      <span class="nodata" v-else>No Data Available</span>
                    </md-table-cell>
                    <md-table-cell style="font-weight:bold;"
                      >Engine No</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_engine_no
                    }}</md-table-cell>
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;"
                      >Vehicle Model</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_type.vehicle_brands
                        .vehicle_brand_name +
                        "-" +
                        fms_vehicle.vehicle_type.vehicle_model +
                        " " +
                        fms_vehicle.vehicle_type.vehicle_year_model
                    }}</md-table-cell>
                    <md-table-cell style="font-weight:bold;"
                      >Chassis No</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_chassis_no
                    }}</md-table-cell>

                    
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;"
                      >Body Color</md-table-cell
                    >
                    <md-table-cell>
                      <span v-if="fms_vehicle.vehicle_body_color == 0"
                        >Putih</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 1"
                        >Putih Kuning</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 2"
                        >Putih Metalik</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 3"
                        >Hitam</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 4"
                        >Hitam Metalik</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 5"
                        >Silver</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 6"
                        >Silver Metalik</span
                      >
                      <span v-if="fms_vehicle.vehicle_body_color == 7">Abu Abu </span>
                      <span v-if="fms_vehicle.vehicle_body_color == 8">Abu Abu Metalik</span>
                      <span v-if="fms_vehicle.vehicle_body_color == 9">N/A</span>
                  
                    </md-table-cell>

                    <md-table-cell style="font-weight:bold;"
                      >MSPF Last Communication Status</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_last_mspf_data ? fms_vehicle.vehicle_last_mspf_data.vehicle_mspf_last_communication_status : 'No Data'
                    }}</md-table-cell>

                    
                    
                  </md-table-row>
                  <md-table-row>
                    <md-table-cell style="font-weight:bold;"
                      >MSPF Last Activation Status</md-table-cell
                    >
                    <md-table-cell>{{
                      fms_vehicle.vehicle_last_mspf_data ? fms_vehicle.vehicle_last_mspf_data.vehicle_mspf_last_activation_status : 'No Data'
                    }}</md-table-cell>

                    
                    
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <template>
        <md-card>
            <v-app>
          <v-card>
            <v-tabs
              color="deep-purple accent-4"
              show-arrows
              centered
              v-model="tab"
            >
              <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

              <v-tab
                :href="'#tab-1'"
              >
                <b>Document</b>
              </v-tab>
              <v-tab
                :href="'#tab-2'"
              >
                <b>Accesories</b>
              </v-tab>
              <v-tab
                :href="'#tab-4'"
              >
                <b>Vehicle Contract</b>
              </v-tab>
              <v-tab
                :href="'#tab-5'"
              >
                <b>Vehicle Ownership</b>
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" touchless>
              <v-tab-item :key="1" value="tab-1">
                <v-col cols="12">
                  <v-card >
                    <md-table>
                      <md-table-row style="background-color:azure">
                        <md-table-head style="text-align:center;"
                          ><b>Type</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Document No</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Expire Date</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Tax Expire Date</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Remark</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Attach</b></md-table-head
                        >
                      </md-table-row>
                      <md-table-row
                        v-if="fms_vehicle.vehicle_document.length == 0"
                      >
                        <md-table-cell class="nodata" colspan="6">
                          No Data Available
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row
                        v-for="(item, index) in fms_vehicle.vehicle_document"
                        :key="index"
                      >
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_document_type == 0"
                            >STNK</span
                          >
                          <span v-if="item.vehicle_document_type == 1"
                            >BPKB</span
                          >
                          <span v-if="item.vehicle_document_type == 2"
                            >KEUR</span
                          >
                          <span v-if="item.vehicle_document_type == 3"
                            >TERA</span
                          >
                          <span v-if="item.vehicle_document_type == 4"
                            >SRUT</span
                          >
                          <span v-if="item.vehicle_document_type == 5">KP</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">{{
                          item.vehicle_document_no
                        }}</md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_document_expire_date">{{
                            item.vehicle_document_expire_date
                          }}</span>
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_document_tax_expire_date">{{
                            item.vehicle_document_tax_expire_date
                          }}</span>
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_document_remark">{{
                            item.vehicle_document_remark
                          }}</span>
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.url_vehicle_document_file">
                            <a
                              v-if="item.url_vehicle_document_file"
                              :href="item.url_vehicle_document_file"
                              target="_blank"
                            >
                              View File
                            </a></span
                          >

                          <span v-else style="">-</span>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </v-card>
                </v-col>
              </v-tab-item>
              <v-tab-item :key="2" value="tab-2">
                <v-col cols="12">
                  <v-card>
                    <md-table>
                      <md-table-row style="background-color:azure">
                        <md-table-head style="text-align:center;"
                          ><b>Type</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Series No</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Installation Date</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Installation By</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Remark</b></md-table-head
                        >
                        <md-table-head style="text-align:center;"
                          ><b>Attach</b></md-table-head
                        >
                      </md-table-row>
                      <md-table-row
                        v-if="fms_vehicle.vehicle_accessory.length == 0"
                      >
                        <md-table-cell class="nodata" colspan="6">
                          No Data Available
                        </md-table-cell>
                      </md-table-row>
                      <md-table-row
                        v-else
                        v-for="(item, index) in fms_vehicle.vehicle_accessory"
                        :key="index"
                      >
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_accesory_type == 0"
                            >RDS+SIM-CARD</span
                          >
                          <span v-if="item.vehicle_accesory_type == 1"
                            >Bracket RDS</span
                          >
                          <span v-if="item.vehicle_accesory_type == 2"
                            >Crown</span
                          >
                          <span v-if="item.vehicle_accesory_type == 3"
                            >Emergency Lamp</span
                          >
                          <span v-if="item.vehicle_accesory_type == 4"
                            >Vacancy Lamp</span
                          >
                          <span v-if="item.vehicle_accesory_type == 5"
                            >Sticker</span
                          >
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_accesory_serial_no">{{
                            item.vehicle_accesory_serial_no
                          }}</span>
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span
                            v-if="item.vehicle_accesory_installation_date"
                            >{{ item.vehicle_accesory_installation_date }}</span
                          >
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_accesory_installation_by">{{
                            item.vehicle_accesory_installation_by
                          }}</span>
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.vehicle_accesory_remark">{{
                            item.vehicle_accesory_remark
                          }}</span>
                          <span v-else style="">-</span>
                        </md-table-cell>
                        <md-table-cell style="text-align:center;">
                          <span v-if="item.url_vehicle_accessory_file">
                            <a
                              v-if="item.url_vehicle_accessory_file"
                              :href="item.url_vehicle_accessory_file"
                              target="_blank"
                            >
                              View File
                            </a></span
                          >
                          <span v-else style="">-</span>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </v-card>
                </v-col>
              </v-tab-item>
              
              <v-tab-item :key="4" value="tab-4">
                <v-col cols="12">
                <v-card>
                  <v-card-title>
                    History PKO
                  </v-card-title>
                  <md-table>
                  <md-table-row style="background-color:azure">
                    <md-table-head><b>PKO No</b></md-table-head>
                    <md-table-head><b>Driver Name</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <!-- <md-table-head><b>Terminated Date</b></md-table-head> -->
                    <!-- <md-table-head><b>Vehicle No</b></md-table-head>
                    <md-table-head><b>Plate No</b></md-table-head> -->
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(item,index) in fms_vehicle.vehicle_list_pko" :key="index">
                    <md-table-cell>{{ item.pko_no }}</md-table-cell>
                    <md-table-cell>{{ item.driver.driver_name }}</md-table-cell>
                    <md-table-cell>{{ item.pko_start_date }}</md-table-cell>
                    <!-- <md-table-cell>{{  }}</md-table-cell>
                    <md-table-cell>{{  }}</md-table-cell> -->
                    <md-table-cell v-if="item.current_status">
                      <span v-if="item.current_status.status==0">Registered</span>
                      <span v-if="item.current_status.status==1">Waiting Approval</span>
                      <span v-if="item.current_status.status==2">Rejected</span>
                      <span v-if="item.current_status.status==3">Active</span>
                      <span v-if="item.current_status.status==4">Payment Completed</span>
                      <span v-if="item.current_status.status==5">Terminated by Payment</span>
                      <span v-if="item.current_status.status==6">Change to Ownership</span>
                    </md-table-cell>
                  </md-table-row>
                  <md-table-row v-if="fms_vehicle.vehicle_list_pko.length==0">
                    <md-table-cell colspan="8" class="nodata"
                      >No Data Available</md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </v-card>
            </v-col>
              <v-col cols="12">
                <v-card v-if="fms_vehicle.vehicle_pko_active!=null">
                  <v-card-title>
                    <div>SPJ (PKO Active)</div>
                  </v-card-title>
                  <md-table>
                  <md-table-row style="background-color:azure">
                    <!-- <md-table-head><b>PKO No</b></md-table-head> -->
                    <md-table-head><b>SPJ No</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <md-table-head><b>Due Date</b></md-table-head>
                    <md-table-head><b>Weekly</b></md-table-head>
                    <md-table-head><b>Penalty</b></md-table-head>
                    <md-table-head><b>Total Payable</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(item,index) in fms_vehicle.vehicle_pko_active.spj" :key="index">
                    <md-table-cell>{{ item.spj_no }}</md-table-cell>
                    <md-table-cell>{{ item.spj_start_date }}</md-table-cell>
                    <md-table-cell>{{ item.spj_due_date}}</md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.spj_weekly_installment) }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.spj_penalty) }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.spj_weekly_installment + item.spj_penalty) }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.payment_amount) }}</span>
                    </md-table-cell>
                    <md-table-cell v-if="item.current_status">
                                <span v-if="item.current_status.status==0">Registered</span>
                                <span v-if="item.current_status.status==1">Partially Paid</span>
                                <span v-if="item.current_status.status==2">Paid</span>
                                <span v-if="item.current_status.status == 3">Unpaid</span>
                                <span v-if="item.current_status.status == 4">Active</span>
                              </md-table-cell>
                              <md-table-cell v-else>
                              </md-table-cell>
                  </md-table-row>
                </md-table>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card v-if="fms_vehicle.vehicle_pko_ownership_active!=null">
                  <v-card-title>
                    SPJ (PKO Ownership Active)
                  </v-card-title>
                  <md-table>
                  <md-table-row style="background-color:azure">
                    <!-- <md-table-head><b>PKO No</b></md-table-head> -->
                    <md-table-head><b>SPJ No</b></md-table-head>
                    <md-table-head><b>Start Date</b></md-table-head>
                    <md-table-head><b>Due Date</b></md-table-head>
                    <md-table-head><b>Weekly</b></md-table-head>
                    <md-table-head><b>Penalty</b></md-table-head>
                    <md-table-head><b>Total Payable</b></md-table-head>
                    <md-table-head><b>Paid Amount</b></md-table-head>
                    <md-table-head><b>Status</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-for="(item,index) in fms_vehicle.vehicle_pko_ownership_active.spj" :key="index">
                    <md-table-cell>{{ item.spj_no }}</md-table-cell>
                    <md-table-cell>{{ item.spj_start_date }}</md-table-cell>
                    <md-table-cell>{{ item.spj_due_date}}</md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.spj_weekly_installment) }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.spj_penalty) }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.spj_weekly_installment + item.spj_penalty) }}</span>
                    </md-table-cell>
                    <md-table-cell>
                      <span style="float:left">Rp.</span>
                      <span style="float:right">{{ formatPrice(item.payment_amount) }}</span>
                    </md-table-cell>
                    <md-table-cell v-if="item.current_status">
                                <span v-if="item.current_status.status==0">Registered</span>
                                <span v-if="item.current_status.status==1">Partially Paid</span>
                                <span v-if="item.current_status.status==2">Paid</span>
                                <span v-if="item.current_status.status == 3">Unpaid</span>
                                <span v-if="item.current_status.status == 4">Active</span>
                              </md-table-cell>
                              <md-table-cell v-else>
                              </md-table-cell>
                  </md-table-row>
                </md-table>
                </v-card>
              </v-col>
              </v-tab-item>
              <v-tab-item :key="5" value="tab-5">
                <v-col cols="12">
                  <v-card>
                    <v-card-title>
                      <v-btn
                    color="primary"
                    dark
                    class="ma-2"
                    @click="openAddOwnership(fms_vehicle.id)"
                    v-if="role.create"
                    >
                      Add Ownership
                    </v-btn>
                  </v-card-title>
                    <v-data-table 
                      mobile-breakpoint
                      :headers="headers"
                      :items="vehicle_ownership"
                      :loading="loadTable"
                      loading-text="Loading... Please wait"
                      ref="vTable"
                      fixed-header
                      :options.sync="options"
                      :server-items-length="totalDataTable"
                      :page="page"
                      :pageCount="numberOfPages"
                      :footer-props="{'items-per-page-options':[15, 25, 50]}"
                    >
                      <template v-slot:[`item.vehicle_ownership_body_color`]="{ item }">
                        <span v-if="item.vehicle_ownership_body_color == 0"
                            >Putih</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 1"
                            >Putih Kuning</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 2"
                            >Putih Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 3"
                            >Hitam</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 4"
                            >Hitam Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 5"
                            >Silver</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 6"
                            >Silver Metalik</span
                          >
                          <span v-if="item.vehicle_ownership_body_color == 7">Abu Abu </span>
                          <span v-if="item.vehicle_ownership_body_color == 8">Abu Abu Metalik</span>
                          <span v-if="item.vehicle_ownership_body_color == 9">N/A</span>
                      </template>

                      <template v-slot:[`item.vehicle_ownership_created_by`]="{ item }">
                        <span v-if="item.vehicle_ownership_created_by!=null">{{ item.vehicle_ownership_created_by.name }}</span>
                      </template>

                      <template v-slot:[`item.vehicle_ownership_updated_by`]="{ item }">
                        <span v-if="item.vehicle_ownership_updated_by!=null">{{ item.vehicle_ownership_updated_by.name }}</span>
                      </template>

                      <template v-slot:[`item.actions`]="{ item }" >
                        <md-button class="md-dense md-icon-button md-info" v-if="role.update"  v-on:click="openEditOwnership(item.id)" >
                          <md-icon>edit</md-icon>
                        </md-button>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
          </v-app>
        </md-card>
        
      </template>

      <!-- <div class="md-layout-item md-size-100">
        <tabs
                
        :tab-active="1"
        :tab-name="['Document', 'Accesories', 'MCCS', 'Vehicle Contract','Vehicle Ownership']"
        color-button="primary"
        plain>
        
        <template slot="tab-pane-1" class="justify-content">
          <md-card>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head style="text-align:center;"
                    ><b>Type</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Document No</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Expire Date</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Tax Expire Date</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Remark</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Attach</b></md-table-head
                  >
                </md-table-row>
                <md-table-row
                  v-if="fms_vehicle.vehicle_document.length == 0"
                >
                  <md-table-cell class="nodata" colspan="6">
                    No Data Available
                  </md-table-cell>
                </md-table-row>
                <md-table-row
                  v-for="(item, index) in fms_vehicle.vehicle_document"
                  :key="index"
                >
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_document_type == 0"
                      >STNK</span
                    >
                    <span v-if="item.vehicle_document_type == 1"
                      >BPKB</span
                    >
                    <span v-if="item.vehicle_document_type == 2"
                      >KEUR</span
                    >
                    <span v-if="item.vehicle_document_type == 3"
                      >TERA</span
                    >
                    <span v-if="item.vehicle_document_type == 4"
                      >SRUT</span
                    >
                    <span v-if="item.vehicle_document_type == 5">KP</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">{{
                    item.vehicle_document_no
                  }}</md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_document_expire_date">{{
                      item.vehicle_document_expire_date
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_document_tax_expire_date">{{
                      item.vehicle_document_tax_expire_date
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_document_remark">{{
                      item.vehicle_document_remark
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.url_vehicle_document_file">
                      <a
                        v-if="item.url_vehicle_document_file"
                        :href="item.url_vehicle_document_file"
                        target="_blank"
                      >
                        View File
                      </a></span
                    >

                    <span v-else style="">-</span>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </template>

        <template slot="tab-pane-2" class="justify-content">
          <md-card>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head style="text-align:center;"
                    ><b>Type</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Series No</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Installation Date</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Installation By</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Remark</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Attach</b></md-table-head
                  >
                </md-table-row>
                <md-table-row
                  v-if="fms_vehicle.vehicle_accessory.length == 0"
                >
                  <md-table-cell class="nodata" colspan="6">
                    No Data Available
                  </md-table-cell>
                </md-table-row>
                <md-table-row
                  v-else
                  v-for="(item, index) in fms_vehicle.vehicle_accessory"
                  :key="index"
                >
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_accesory_type == 0"
                      >RDS+SIM-CARD</span
                    >
                    <span v-if="item.vehicle_accesory_type == 1"
                      >Bracket RDS</span
                    >
                    <span v-if="item.vehicle_accesory_type == 2"
                      >Crown</span
                    >
                    <span v-if="item.vehicle_accesory_type == 3"
                      >Emergency Lamp</span
                    >
                    <span v-if="item.vehicle_accesory_type == 4"
                      >Vacancy Lamp</span
                    >
                    <span v-if="item.vehicle_accesory_type == 5"
                      >Sticker</span
                    >
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_accesory_serial_no">{{
                      item.vehicle_accesory_serial_no
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span
                      v-if="item.vehicle_accesory_installation_date"
                      >{{ item.vehicle_accesory_installation_date }}</span
                    >
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_accesory_installation_by">{{
                      item.vehicle_accesory_installation_by
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.vehicle_accesory_remark">{{
                      item.vehicle_accesory_remark
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.url_vehicle_accessory_file">
                      <a
                        v-if="item.url_vehicle_accessory_file"
                        :href="item.url_vehicle_accessory_file"
                        target="_blank"
                      >
                        View File
                      </a></span
                    >
                    <span v-else style="">-</span>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </template>
        
        <template slot="tab-pane-3" class="justify-content">
          <md-card>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head style="text-align:center;"
                    ><b>Serial No</b></md-table-head
                  >

                  <md-table-head style="text-align:center;"
                    ><b>MSPF Id</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Device Type</b></md-table-head
                  >
                  <md-table-head style="text-align:center;"
                    ><b>Mobile No</b></md-table-head
                  >
                </md-table-row>
                <md-table-row v-if="fms_vehicle.vehicle_mccs.length == 0">
                  <md-table-cell class="nodata" colspan="4">
                    No Data Available
                  </md-table-cell>
                </md-table-row>
                <md-table-row
                  v-else
                  v-for="(item, index) in fms_vehicle.vehicle_mccs"
                  :key="index"
                >
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.mccs_serial_no">{{
                      item.mccs_serial_no
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.mccs_mspf_id">{{
                      item.mccs_mspf_id
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.mccs_device_type">{{
                      item.mccs_device_type
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                  <md-table-cell style="text-align:center;">
                    <span v-if="item.mccs_mobile_no">{{
                      item.mccs_mobile_no
                    }}</span>
                    <span v-else style="">-</span>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </template>
        <template slot="tab-pane-4">
          <md-card style="margin-top:20mm;">
            <md-card-header
              class="md-card-header-text md-card-header-blue"
            >
                <h4 class="title">History PKO</h4>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head><b>PKO No</b></md-table-head>
                  <md-table-head><b>Driver Name</b></md-table-head>
                  <md-table-head><b>Start Date</b></md-table-head>
                  <md-table-head><b>Status</b></md-table-head>
                </md-table-row>
                <md-table-row v-for="(item,index) in fms_vehicle.vehicle_list_pko" :key="index">
                  <md-table-cell>{{ item.pko_no }}</md-table-cell>
                  <md-table-cell>{{ item.driver.driver_name }}</md-table-cell>
                  <md-table-cell>{{ item.pko_start_date }}</md-table-cell>
                  <md-table-cell v-if="item.current_status">
                    <span v-if="item.current_status.status==0">Registered</span>
                    <span v-if="item.current_status.status==1">Waiting Approval</span>
                    <span v-if="item.current_status.status==2">Rejected</span>
                    <span v-if="item.current_status.status==3">Active</span>
                    <span v-if="item.current_status.status==4">Payment Completed</span>
                    <span v-if="item.current_status.status==5">Terminated by Payment</span>
                    <span v-if="item.current_status.status==6">Change to Ownership</span>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-if="fms_vehicle.vehicle_list_pko.length==0">
                  <md-table-cell colspan="8" class="nodata"
                    >No Data Available</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>

          <md-card style="margin-top:20mm;">
            <md-card-header
              class="md-card-header-text md-card-header-blue"
            >
                <h4 class="title">History PKO Ownership</h4>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head><b>PKO No</b></md-table-head>
                  <md-table-head><b>Driver Name</b></md-table-head>
                  <md-table-head><b>Start Date</b></md-table-head>
                  <md-table-head><b>Status</b></md-table-head>
                </md-table-row>
                <md-table-row v-for="(item,index) in fms_vehicle.vehicle_list_pko_ownership" :key="index">
                  <md-table-cell>{{ item.pko_no }}</md-table-cell>
                  <md-table-cell>{{ item.driver.driver_name }}</md-table-cell>
                  <md-table-cell>{{ item.pko_start_date }}</md-table-cell>
                  <md-table-cell v-if="item.current_status">
                    <span v-if="item.current_status.status==0">Registered</span>
                    <span v-if="item.current_status.status==1">Waiting Approval</span>
                    <span v-if="item.current_status.status==2">Rejected</span>
                    <span v-if="item.current_status.status==3">Active</span>
                    <span v-if="item.current_status.status==4">Payment Completed</span>
                    <span v-if="item.current_status.status==5">Terminated by Payment</span>
                    <span v-if="item.current_status.status==6">Change to Ownership</span>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-if="fms_vehicle.vehicle_list_pko_ownership.length==0">
                  <md-table-cell colspan="8" class="nodata"
                    >No Data Available</md-table-cell
                  >
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>

          <md-card style="margin-top:20mm;" v-if="fms_vehicle.vehicle_pko_active!=null">
            <md-card-header
              class="md-card-header-text md-card-header-blue"
            >
                <h4 class="title">SPJ (PKO Active)</h4>
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head><b>SPJ No</b></md-table-head>
                  <md-table-head><b>Start Date</b></md-table-head>
                  <md-table-head><b>Due Date</b></md-table-head>
                  <md-table-head><b>Weekly</b></md-table-head>
                  <md-table-head><b>Penalty</b></md-table-head>
                  <md-table-head><b>Total Payable</b></md-table-head>
                  <md-table-head><b>Paid Amount</b></md-table-head>
                  <md-table-head><b>Status</b></md-table-head>
                </md-table-row>
                <md-table-row v-for="(item,index) in fms_vehicle.vehicle_pko_active.spj" :key="index">
                  <md-table-cell>{{ item.spj_no }}</md-table-cell>
                  <md-table-cell>{{ item.spj_start_date }}</md-table-cell>
                  <md-table-cell>{{ item.spj_due_date}}</md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.spj_weekly_installment) }}</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.spj_penalty) }}</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.spj_weekly_installment + item.spj_penalty) }}</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.payment_amount) }}</span>
                  </md-table-cell>
                  <md-table-cell v-if="item.current_status">
                              <span v-if="item.current_status.status==0">Registered</span>
                              <span v-if="item.current_status.status==1">Partially Paid</span>
                              <span v-if="item.current_status.status==2">Paid</span>
                              <span v-if="item.current_status.status == 3">Unpaid</span>
                              <span v-if="item.current_status.status == 4">Active</span>
                            </md-table-cell>
                            <md-table-cell v-else>
                            </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>

          <md-card style="margin-top:20mm;" v-if="fms_vehicle.vehicle_pko_ownership_active!=null">
            <md-card-header
              class="md-card-header-text md-card-header-blue"
            >
                <h4 class="title">SPJ (PKO Ownership Active)</h4>
              
            </md-card-header>
            <md-card-content>
              <md-table>
                <md-table-row style="background-color:azure">
                  <md-table-head><b>SPJ No</b></md-table-head>
                  <md-table-head><b>Start Date</b></md-table-head>
                  <md-table-head><b>Due Date</b></md-table-head>
                  <md-table-head><b>Weekly</b></md-table-head>
                  <md-table-head><b>Penalty</b></md-table-head>
                  <md-table-head><b>Total Payable</b></md-table-head>
                  <md-table-head><b>Paid Amount</b></md-table-head>
                  <md-table-head><b>Status</b></md-table-head>
                </md-table-row>
                <md-table-row v-for="(item,index) in fms_vehicle.vehicle_pko_ownership_active.spj" :key="index">
                  <md-table-cell>{{ item.spj_no }}</md-table-cell>
                  <md-table-cell>{{ item.spj_start_date }}</md-table-cell>
                  <md-table-cell>{{ item.spj_due_date}}</md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.spj_weekly_installment) }}</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.spj_penalty) }}</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.spj_weekly_installment + item.spj_penalty) }}</span>
                  </md-table-cell>
                  <md-table-cell>
                    <span style="float:left">Rp.</span>
                    <span style="float:right">{{ formatPrice(item.payment_amount) }}</span>
                  </md-table-cell>
                  <md-table-cell v-if="item.current_status">
                              <span v-if="item.current_status.status==0">Registered</span>
                              <span v-if="item.current_status.status==1">Partially Paid</span>
                              <span v-if="item.current_status.status==2">Paid</span>
                              <span v-if="item.current_status.status == 3">Unpaid</span>
                              <span v-if="item.current_status.status == 4">Active</span>
                            </md-table-cell>
                            <md-table-cell v-else>
                            </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </template>
        <template slot="tab-pane-5">
          <md-card>
            <md-card-content>
              <v-app  class="md-layout-item md-size-100">
                <v-card-title>
                  <v-btn
                color="primary"
                dark
                class="ma-2"
                @click="openAddOwnership(fms_vehicle.id)"
                v-if="role.create"
                >
                  Add Ownership
                </v-btn>
              </v-card-title>
                <v-data-table 
                  mobile-breakpoint
                  :headers="headers"
                  :items="vehicle_ownership"
                  :loading="loadTable"
                  loading-text="Loading... Please wait"
                  ref="vTable"
                  fixed-header
                  :options.sync="options"
                  :server-items-length="totalDataTable"
                  :page="page"
                  :pageCount="numberOfPages"
                  :footer-props="{'items-per-page-options':[15, 25, 50]}"
                >
                  <template v-slot:[`item.vehicle_ownership_body_color`]="{ item }">
                    <span v-if="item.vehicle_ownership_body_color == 0"
                        >Putih</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 1"
                        >Putih Kuning</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 2"
                        >Putih Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 3"
                        >Hitam</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 4"
                        >Hitam Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 5"
                        >Silver</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 6"
                        >Silver Metalik</span
                      >
                      <span v-if="item.vehicle_ownership_body_color == 7">Abu Abu </span>
                      <span v-if="item.vehicle_ownership_body_color == 8">Abu Abu Metalik</span>
                      <span v-if="item.vehicle_ownership_body_color == 9">N/A</span>
                  </template>

                  <template v-slot:[`item.vehicle_ownership_created_by`]="{ item }">
                    <span v-if="item.vehicle_ownership_created_by!=null">{{ item.vehicle_ownership_created_by.name }}</span>
                  </template>

                  <template v-slot:[`item.vehicle_ownership_updated_by`]="{ item }">
                    <span v-if="item.vehicle_ownership_updated_by!=null">{{ item.vehicle_ownership_updated_by.name }}</span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }" >
                    <md-button class="md-dense md-icon-button md-info" v-if="role.update"  v-on:click="openEditOwnership(item.id)" >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </template>
                </v-data-table>
              </v-app>
            </md-card-content>
          </md-card>
        </template>

      </tabs>
      </div> -->
    

    <div v-bind:style="{ display: not_found }">
      <center v-if="fms_vehicle == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Back To List?</a>
        </p>
      </center>
    </div>
    </div>
    <modal ref="modalAddOwnershipPage" class="coba">
      <template v-slot:header>
        <div>
          <h3>Add Ownership</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="modalCloseAddOwnership()"><md-icon>close</md-icon></md-button>
      </template>
      <template v-slot:body>
        <add-ownership :data_id="$refs.modalAddOwnershipPage.data" />
      </template>
    </modal>
    <modal ref="modalEditOwnershipPage" class="coba">
      <template v-slot:header>
        <div>
          <h3>Edit Ownership</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="modalCloseEditOwnership()"><md-icon>close</md-icon></md-button>
      </template>
      <template v-slot:body>
        <edit-ownership :data_id="$refs.modalEditOwnershipPage.data" />
      </template>
    </modal>
  </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import EditOwnership from "@/pages/Dashboard/Fms/Vehicle/modal/EditOwner.vue";
import AddOwnership from "@/pages/Dashboard/Fms/Vehicle/modal/AddOwner.vue";
import { Modal } from "@/components";
import Swal from "sweetalert2";
import vuetify from '@/plugins/vuetify'
import { NavTabsCard } from "@/components";

import Vue from "vue";

const url_storage = process.env.VUE_APP_STORAGE_BASE_URL;
const toLower = (text) => {
  var rt = "";
  if (text) {
    rt = text.toString().toLowerCase();
  }
  return rt;
};
export default {
  name: "detail-vehicles",

  vuetify,
  computed: {
   
  headers() {
    const headers =[
      { text: "Registration Name", value: "vehicle_ownership_registration_name",sortable: false },
      { text: "Body Color", value: "vehicle_ownership_body_color", sortable: false,width:'150' },
      { text: "Plate No", value: "vehicle_ownership_plate_no",sortable: false, width:'150' },
      { text: "Created By", value: "vehicle_ownership_created_by", sortable: false, width:'150' },
      { text: "Updated By", value: "vehicle_ownership_updated_by", sortable: false, width:'150' },
      { text: "Change Date", value: "vehicle_ownership_change_date", sortable: false, width:'150' },
      { text: "Update At", value: "updated_at", sortable: false },
    ]
    console.log(this.role)
    if(this.role.update) {
      headers.unshift({
         text: "Action", value: "actions", align: "start", sortable: false ,
      })
    }

    return headers
  }
},
watch: {
    options: {
      
      handler() {
        if( !this.mounted){
          this.getListOwnership();
        }
      },
      group () {
        this.drawer = false
      },
    },
    deep: true,
  },
  components: {
    "edit-ownership": EditOwnership,
    "add-ownership": AddOwnership,
    Modal , 
  },
  props: {
    data_id: null,
  },

  mixins: [formMixin],

  data: () => ({
    drawer: false,
    group: null,
    tab: "tab-1",
    role_name: "",
    active: false,
    not_found: "none",
    role: "",
    fms_vehicle: null,
    url_storage: url_storage,

    vehicle_ownership: [],

    loadTable: false,
    page: 1,
    options: {},
    totalDataTable: 0,
    numberOfPages: 0,
    valueStatus:'',
    optionStatus:[ 
          { text: 'All', value: '' },
          { text: 'Paid', value: '2' },
          { text: 'Partially Paid', value: '1'},
          { text: 'Registered', value: '0'},
      { text: "Unpaid", value: "3" },
      { text: "Active", value: "4" }],
  }),

   async mounted() {
    // this.onMounted()
    // this.getListSpj();
    this.mounted = false

    },

   async created() {
    this.me = await this.$store.getters["profile/me"]
      this.role =  await this.$store.getters["role_permission/route_filter"]
    this.getVehicleData();
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getVehicleData() {
      //ambil list role permission user
      this.role = await this.$store.getters["role_permission/route_filter"];
      var me = await this.$store.getters["profile/me"];
      this.role_name = me.role_name
      // console.log(this.role)
      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch("fms_vehicle/get", this.data_id.id);
      this.fms_vehicle = await this.$store.getters["fms_vehicle/fms_vehicle"];
      if (!this.fms_vehicle) {
        this.not_found = "block";
        return;
      }
    },

    async getListOwnership() {
      

      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      let itemsPerPageNumber = itemsPerPage;
      
     var query = {"page":{number:pageNumber,size:itemsPerPageNumber}}
      query.filter = {vehicle_ownership_vehicle_id:this.data_id.id}
      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort;
      }


    
     console.log(query);
      await this.$store.dispatch("fms_vehicle_ownership/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.vehicle_ownership = await this.$store.getters["fms_vehicle_ownership/list"];
        var pageMeta  = await this.$store.getters["fms_vehicle_ownership/page"];
      // }
      // else{
      //   this.table = []
      // }

      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },

    async closeDetail(){
      if(this.data_id.mode && this.data_id.mode == "PKOBP"){
          this.$parent.$parent.closeVehiclePKODetail();
        }
        else if(this.data_id.mode && this.data_id.mode == "PKON"){
          this.$parent.$parent.closeVehiclePKODetail();
        }
        else if(this.data_id.mode && this.data_id.mode == "PKOOBP"){
          this.$parent.$parent.closeVehiclePKOOBPDetail();
        }
        else{
          this.$parent.$parent.modalCloseDetail();

        }
    },

    // fungsi currency number
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    // direct ke edit form
    editVehicle(id) {
      //pindah ke page edit, id juga ikut dikirim melalui route
      this.$router.push({
        name: "Edit Vehicle",
        params: { fms_vehicle: id, id },
      });
    },

    // direct ke list view table
    backtoList() {
      //kembali ke list
      this.$router.replace({ name: "List Vehicle" });
    },

    confirmationChangeStatus(status, status_text) {
      Swal.fire({
        title: "Are you sure want to change the status to " + status_text + "?",
        text: "The data will Saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.changeStatus(status);
        }
      });
    },

    async changeStatus(status) {
      const data = {
        type: "fms_vehicles",
        id: this.fms_vehicle.id,
        status: status,
      };
      try {
        await this.$store.dispatch("fms_vehicle/update", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully changed status."
        );
        // var indexOption = this.table.findIndex(p => p.id ==  id)
        // this.table[indexOption].spare_part_transfer_status = status
        this.getVehicleData();
        // this.modalCloseFormPrice()
      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
        console.log(e);
      }
    },

    openAddOwnership(id){
      this.$refs.modalAddOwnershipPage.openModal({id:id})
    },

    modalCloseAddOwnership(){
      this.getListOwnership()
      this.$refs.modalAddOwnershipPage.closeModal()
      
    },


    openEditOwnership(id){
      this.$refs.modalEditOwnershipPage.openModal({id:id})
    },

    modalCloseEditOwnership(){
      this.getListOwnership()
      this.$refs.modalEditOwnershipPage.closeModal()
      
    },


    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteVehicle(id);
        }
      });
    },
    check_object_value(array, key, value) {
        //return array.some(object => object[key] === value);
        return array.some(object => value.includes(object[key]));
        },

    // fungsi delete data
    async deleteVehicle(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("fms_vehicle/destroy", id);
        //panggil alert succes
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle data delete successfully."
        );
        //kembali ke page list
        this.$router.replace({ name: "List Vehicle" });
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title-name {
  background-color: powderblue;
}
table {
  width: 100%;
  table-layout: fixed;
}
.table-kotak {
  border-collapse: collapse;
}
table.table-kotak td {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th {
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print {
  visibility: hidden;
}
@media print {
  .print {
    visibility: visible;
  }
  .noprint {
    display: none;
  }
}
.photo_list {
  max-width: 50%;
  height: auto;
  display: block;
  /* margin-left: auto;
    margin-right: auto; */
}

.nodata {
  color: #aaa;
  text-align: center;
}

.md-card {
  box-shadow: 0 3px 5px 1px rgb(0 0 0/ 14%);
}

.md-toolbar {
  position: relative;
  z-index: 0;
}

.md-content1 {
    max-width: 800px;
    max-height: 500px;
    overflow: auto;
  }

  .color{
  background-color: #1976d2 !important;
}

.coba {
  width: 800px !important;
  height: 610px !important;
  // margin: 50px auto !important;
  // top: auto !important;
  // bottom: auto !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
  }
}
</style>
